import '@affine/core/bootstrap/browser';
